import "./index.scss";
import * as _ from "lodash";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  editProfile,
  readProfile,
} from "../../../../../store/profile/thunkAction";
import {
  sendNotifyIziMessageError,
  sendNotifyIziMessageSuccess,
} from "../../../../../utils/event";

const ProfileBotSetting = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const params = useParams();
  const profileId = _.get(params, "id");

  useEffect(() => {
    dispatch(readProfile(profileId));
  }, [profileId, dispatch]);

  const profileManage = useSelector((state) => state.profileManage);
  const profile = _.get(profileManage, "profile");
  const [isChatBot, setIsChatBot] = useState(false);
  const [endpoint, setEndpoint] = useState("");
  const [credentials, setCredentials] = useState("");

  useEffect(() => {
    setEndpoint(profile.endpoint || "");
    setIsChatBot(profile.isChatBot || false);
    setCredentials(profile.credentials || "");
  }, [profile]);

  const isValidUrl = (url) => {
    try {
      const parsed = new URL(url);
      return parsed.protocol === "http:" || parsed.protocol === "https:";
    } catch {
      return false;
    }
  };

  const saveProfile = async () => {
    if (isChatBot) {
      if (!endpoint.trim()) {
        sendNotifyIziMessageError(t("profile.endpoint_required"));
        return;
      }

      if (!isValidUrl(endpoint)) {
        sendNotifyIziMessageError(t("profile.endpoint_invalid_url"));
        return;
      }
    }

    try {
      await dispatch(
        editProfile({
          id: profileId,
          data: { isChatBot, endpoint, credentials },
        }),
      ).unwrap();

      sendNotifyIziMessageSuccess(t("profile.profile_save_success"));
    } catch (error) {
      const errorCode = _.get(error, "errorCode");
      if (errorCode === "FILE_NOT_ALLOWED") {
        sendNotifyIziMessageError(t("profile.upload_file_error"));
      } else if (errorCode === "FILE_TOO_LARGE") {
        sendNotifyIziMessageError(t("profile.file_too_large"));
      } else {
        sendNotifyIziMessageError(t("profile.profile_save_error"));
      }
    }
  };

  return (
    <div
      className="tab-pane fade active show mt-5"
      id="profiles-tab-pane"
      role="tabpanel"
      aria-labelledby="profiles-tab"
      tabIndex="0"
    >
      <div className="row mb-5">
        <div className="col-lg-3">
          <h5 className="title">{t("settings.profile.bot_setting")}</h5>
        </div>
        <div className="col-lg-7">
          <div className="col-sm-6 mb-4">
            <label className="form-label text-uppercase">
              {t("settings.profile.enabled_bot")}
            </label>
            <label className="form-check form-switch gap-2 d-flex align-items-center">
              <input
                className="form-check-input"
                type="checkbox"
                role="switch"
                checked={isChatBot}
                onChange={(e) => setIsChatBot(e.target.checked)}
              />
              <span>
                {isChatBot ? t("common.enabled") : t("common.disabled")}
              </span>
            </label>
          </div>

          {isChatBot && (
            <div className="row mb-4">
              <div className="col-lg-10">
                <div className="mb-3">
                  <label className="form-label fw-500">
                    {t("settings.profile.endpoint")}
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder=""
                    value={endpoint}
                    onChange={(e) => setEndpoint(e.target.value)}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label fw-500">
                    {t("settings.profile.credentials")}
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    placeholder={""}
                    value={credentials}
                    onChange={(e) => setCredentials(e.target.value)}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="card-footer">
        <div className="d-flex gap-3 justify-content-center align-items-center">
          <button onClick={() => saveProfile()} className="btn btn-primary">
            {t("common.save")} &amp; {t("common.exit")}
          </button>
          <button
            onClick={() => {
              navigate(`/profile/${profileId}/detail`);
            }}
            className="btn btn-gray btn-outline-gray"
          >
            {t("common.exit")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProfileBotSetting;
